import { AtomIcon, FlaskConicalIcon, GlassesIcon, HexagonIcon, LayoutGridIcon, TestTubeIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: 'Matter & Atomic Structure: From Particles to Electron Configuration',
    summary: 'A visual teaching reference to what everything is made of — from particles you cannot see to the electrons that decide how atoms behave.',
    icon: AtomIcon,
  },
  {
    number: '02',
    title: 'The Periodic Table & Chemical Bonding',
    summary: 'A visual teaching reference to how elements are organised — and why atoms hold on to each other.',
    icon: LayoutGridIcon,
  },
  {
    number: '03',
    title: 'Chemical Reactions, the Mole & Stoichiometry',
    summary: 'A visual teaching reference to how substances change — and how chemists count atoms by weighing them.',
    icon: FlaskConicalIcon,
  },
  {
    number: '04',
    title: 'Solutions, Acids & Bases, Rates & Equilibrium',
    summary: 'A visual teaching reference to concentration, pH, titration, how fast reactions go — and why some never finish.',
    icon: TestTubeIcon,
  },
  {
    number: '05',
    title: 'Organic Chemistry: Carbon, Functional Groups & Polymers',
    summary: 'A visual teaching reference to the chemistry of carbon — from simple fuels to fragrances, plastics and the molecules of life.',
    icon: HexagonIcon,
  },
  {
    number: '06',
    title: 'School Laboratory Safety & Practical Chemistry',
    summary: 'A visual teaching reference to running a safe chemistry lab — and teaching the practical skills students use every lesson.',
    icon: GlassesIcon,
  },
];
